import { apiWithBody, ModuleFE_BaseApi } from '@nu-art/thunderstorm-frontend/index';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
import { ApiDef_Variable, DBDef_Variable } from '@app/hcs-shared';
import { BadImplementationException, filterInstances } from '@nu-art/ts-common';
import { ModuleFE_NLPData } from '../nlp-data/ModuleFE_NLPData.js';
import { ModuleFE_Value } from '../value/ModuleFE_Value.js';
import { ModuleFE_Expression } from '../expression/ModuleFE_Expression.js';
import { ModuleFE_Discussion } from '../discussion/ModuleFE_Discussion.js';
export const dispatch_onVariableChanged = new ThunderDispatcherV3('__onVariableUpdated');
export class ModuleFE_Variable_Class extends ModuleFE_BaseApi {
    _v1;
    __searchGroups = (items) => ([{
            group: this.dbDef.entityName,
            results: items.map(i => ({ _id: i._id, uiLabel: i.name }))
        }]);
    __searchFilterMapper = (item) => {
        const nlpData = ModuleFE_NLPData.cache.unique(item.nlpDataId);
        return filterInstances([item.name, nlpData?.synonyms.join('  '), item._id]);
    };
    __searchGroupsRefs = (items) => {
        let results = items.map(reference => (this.cache.find(variable => variable.referenceIds.includes(reference._id))));
        results = results.filter(item => item);
        return [{
                group: this.dbDef.entityName,
                results: results.map(item => ({ _id: item?._id, uiLabel: item?.name }))
            }];
    };
    constructor() {
        super(DBDef_Variable, dispatch_onVariableChanged);
        this._v1 = {
            getVariables: apiWithBody(ApiDef_Variable._v1.getVariables),
            getAttributes: apiWithBody(ApiDef_Variable._v1.getAttributes),
            createAttributeInstance: apiWithBody(ApiDef_Variable._v1.createAttributeInstance, this.onAttributeInstanceCreated),
            createChild: apiWithBody(ApiDef_Variable._v1.createChild, this.onChildCreated),
            createUIVariable: apiWithBody(ApiDef_Variable._v1.createUIVariable, async (response, uiVar) => {
                /*FIXME: reading original like this is wrong, also onEntryUpdated does not assume that there might not be an original,
                                                 so an empty object is sent instead.
                                                 fix this when response is fixed to send the body as an object and not as a string!
                */
                //Updated known changes
                await this.onEntriesUpdated(response.dbVar);
                await ModuleFE_Value.onEntriesUpdated(response.dbValues);
                if (response.expression) {
                    await ModuleFE_Expression.onEntriesUpdated([response.expression]);
                }
            }),
            deleteVariable: apiWithBody(ApiDef_Variable._v1.deleteVariable, async (res) => {
                await this.onEntryDeleted(res.deletedVariable);
                if (res.deletedExpressions)
                    await ModuleFE_Expression.onEntriesUpdated(res.deletedExpressions);
            }),
            convertToYesSusNo: apiWithBody(ApiDef_Variable._v1.convertToYesSusNo, async (response) => {
                await this.onEntriesUpdated([response.variable]);
                await ModuleFE_Expression.onEntriesUpdated(response.expressions);
            })
        };
        // ModuleFE_References.__searchGroups = this.__searchGroupsRefs;
    }
    init() {
        super.init();
        ModuleFE_Discussion.registerLabelFromEntityConverter(this.dbDef.dbKey, (variable) => variable.name);
    }
    getVariableIdForValueId = (valueId) => {
        const value = ModuleFE_Value.cache.unique(valueId);
        if (!value)
            throw new BadImplementationException(`Could not find value for id ${valueId}`);
        switch (value.type) {
            case 'tuple': {
                this.logWarning('Trying to get a variable for a tuple value, too many answers!');
                return undefined;
            }
            case 'enum-element': {
                const parent = ModuleFE_Value.cache.find(parent => parent.type === 'enumerated' && parent.data.scope.includes(value._id));
                if (!parent)
                    throw new BadImplementationException(`Could not find parent value for value with id ${valueId}`);
                const variable = this.cache.find(variable => variable.valueId === parent._id);
                if (!variable)
                    throw new BadImplementationException(`Could not find variable for value with id ${parent._id}`);
                return variable._id;
            }
            case 'sub-range': {
                const parent = ModuleFE_Value.cache.find(parent => parent.type === 'range' && parent.data.subsets.includes(valueId));
                if (!parent)
                    throw new BadImplementationException(`Could not find parent value for value with id ${valueId}`);
                const variable = this.cache.find(variable => variable.valueId === parent._id);
                if (!variable)
                    throw new BadImplementationException(`Could not find variable for value with id ${parent._id}`);
                return variable._id;
            }
            case 'range':
            case 'enumerated': {
                const variable = this.cache.find(variable => variable.valueId === valueId);
                if (!variable)
                    throw new BadImplementationException(`Could not find variable for value with id ${valueId}`);
                return variable._id;
            }
        }
    };
    onAttributeInstanceCreated = async (response) => {
        await ModuleFE_Value.onEntriesUpdated([response.value]);
        await this.onEntriesUpdated([response.variable]);
    };
    onChildCreated = async (response) => {
        await this.onEntriesUpdated([response.child]);
    };
}
export const ModuleFE_Variable = new ModuleFE_Variable_Class();
//# sourceMappingURL=ModuleFE_Variable.js.map